import { useUserPreferencesContext } from '../context/UserPreferencesContext';

/**
 * Custom hook for managing user preferences (home page and favorites)
 *
 * This hook provides access to the UserPreferencesContext and is the primary
 * interface for components to interact with user preferences.
 *
 * Uses React Context with localStorage persistence per project architecture standards.
 *
 * @example
 * ```tsx
 * const { homePage, favorites, setHomePage, addFavorite, isFavorite } = useUserPreferences();
 *
 * // Set home page
 * setHomePage('/communities/abc123/moderation');
 *
 * // Add a favorite
 * addFavorite({
 *   id: 'abc123',
 *   type: 'community',
 *   label: 'Halo Studios',
 *   route: '/communities/abc123',
 * });
 *
 * // Check if item is favorited
 * const isFav = isFavorite('abc123');
 * ```
 */
export function useUserPreferences() {
  return useUserPreferencesContext();
}
